<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-col lg="12">
        <card header-classes="bg-transparent">
          <b-row class="mb-4">
            <b-col lg="9" xl="10" md="12" class="d-flex flex-column mb-4">
              <h2 slot="header" class="mb-0">จัดการพนักงาน</h2>
              <div class="text-body-1">
                แสดงตารางรายละเอียดพนักงานทั้งหมดภายใน
              </div>
            </b-col>
            <b-col lg="3" xl="2" md="12" class="text-right">
              <base-button
                type="primary"
                class="d-flex align-items-center"
                block
                @click="openModalAdmin()">
                <b-icon icon="plus" class="mr-2"></b-icon> เพิ่มพนักงาน
              </base-button>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <b-col lg="4" md="12" class="mb-2">
              <b-form-input
                v-model="searchTerm"
                placeholder="ค้นหาชื่อพนักงาน"
                @input="onSearchInput">
              </b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <b-table responsive :fields="fields" :items="admins">
                <template #cell(index)="data">
                  {{
                    (pagination.currentPage - 1) * pagination.perPage +
                    data.index +
                    1
                  }}
                </template>
                <template #cell(firstname)="data">
                  {{ data.item.firstname }} {{ data.item.lastname }}
                </template>
                <template #cell(manage)="data">
                  <b-button
                    variant="outline-border"
                    size="sm"
                    @click="setEditAdmin(data.item)">
                    <b-icon icon="pencil-square"></b-icon>
                  </b-button>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="openModalConfirm(data.item.id)">
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex justify-content-end">
              <b-pagination
                v-model="pagination.currentPage"
                :disabled="isLoading"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="my-table"
                class="mt-3"
                @change="(page) => getAdmin(page)"></b-pagination>
            </b-col>
          </b-row>
        </card>
      </b-col>
      <ModalAdmin :form="form" @getAdmin="getAdmin" />
      <ModalConfirm
        ref="confirmDelete"
        :confirm="confirm"
        @confirmModal="onDeleteAdmin" />
    </b-container>
  </div>
</template>

<script>
import ModalAdmin from "@/components/Admin/ModalAdmin.vue";
import adminServices from "@/api/admin.service.js";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import createDebouncedFunction from "@/util/debounce.js";
import { getCancelToken } from "@/util/axiosCancel";

export default {
  components: { ModalAdmin, ModalConfirm },
  data() {
    return {
      isLoadPage: false,
      isLoading: false,
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
      },
      searchTerm: "",
      admins: [],
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "firstname",
          label: "ชื่อ-นามสกุล",
        },
        {
          key: "email",
          label: "อีเมลที่เข้าสู่ระบบ",
        },
        // {
        //     key: "phonenumber",
        //     label: "เบอร์โทรศัพท์",
        // },
        {
          key: "role",
          label: "สิทธิการเข้าถึง",
          class: "text-center",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
      confirm: {
        show: false,
        icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
        emphasize: "ต้องการลบรายการ",
        text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
        isLoad: false,
        id: null,
      },
      form: {
        show: false,
        isLoad: false,
        admin: {
          id: null,
          email: null,
          password: null,
          firstName: null,
          lastName: null,
          tel: null,
          role: null,
        },
      },
    };
  },
  created() {
    this.getAdmin();
  },
  methods: {
    onSearchInput: createDebouncedFunction(function () {
      this.getAdmin();
    }, 500),
    async getAdmin(page = 1) {
      this.isLoading = true;
      this.isLoadPage = true;
      try {
        const cancelToken = getCancelToken();
        const response = await adminServices.getAdmin(
          {
            page,
            filters: this.searchTerm,
          },
          cancelToken
        );

        this.admins = response.data.data.items;
        this.pagination.totalRows = response.data.data.meta.totalItems;
        this.pagination.perPage = response.data.data.meta.itemsPerPage;
        this.pagination.currentPage = response.data.data.meta.currentPage;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
        this.isLoadPage = false;
      }
    },
    async onDeleteAdmin() {
      try {
        this.isLoadPage = true;
        await adminServices.removeAdmin(this.confirm.id);
        this.getAdmin();
        this.$refs.confirmDelete.closeModalConfirm();
      } catch (error) {
      } finally {
        this.isLoadPage = false;
      }
    },
    openModalAdmin() {
      this.form.show = true;
    },
    openModalConfirm(userId) {
      this.confirm.show = true;
      this.confirm.id = userId;
      this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
      this.confirm.emphasize = "ต้องการลบรายการ";
      this.confirm.text =
        "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
    },
    setEditAdmin(item) {
      this.form.admin.id = item.id;
      this.form.admin.email = item.email;
      this.form.admin.firstName = item.firstname;
      this.form.admin.lastName = item.lastname;
      this.form.admin.tel = item.phonenumber;
      this.form.admin.role = item.role;

      this.openModalAdmin();
    },
  },
};
</script>
